import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from './auth';

// API client para la administración cross-tenant (uso del superTenant STIL).
// Todos los endpoints requieren JWT de USER_LIFTLOGIC. El backend además
// audita las operaciones con tag [SUPER_TENANT_AUDIT].

const authHeaders = () => ({
  Authorization: getAccessTokenApi(),
  'Content-Type': 'application/json',
});

export const listTenantsAdmin = async () => {
  const res = await axios.get(`${API_PATH}/tenants/admin/list`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createTenantAdmin = async (payload) => {
  const res = await axios.post(`${API_PATH}/tenants/admin/create`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};

export const updateTenantAdmin = async (id, updates) => {
  const res = await axios.patch(`${API_PATH}/tenants/admin/${id}`, updates, {
    headers: authHeaders(),
  });
  return res.data;
};

export const setTenantStatus = async (id, status) => {
  const res = await axios.patch(
    `${API_PATH}/tenants/admin/${id}/status`,
    { status },
    { headers: authHeaders() }
  );
  return res.data;
};

export const getTenantConfigCatalog = async () => {
  const res = await axios.get(`${API_PATH}/tenants/config-catalog`, {
    headers: authHeaders(),
  });
  return res.data; // { catalog }
};

export const uploadTenantLogo = async (id, file) => {
  const fd = new FormData();
  fd.append('logo', file);
  const res = await axios.post(`${API_PATH}/tenants/admin/${id}/logo`, fd, {
    headers: {
      Authorization: getAccessTokenApi(),
      // 'Content-Type' lo define el browser con el boundary de multipart
    },
  });
  return res.data;
};
